import { ArtifactCard } from './artifact-card';
import { ArtifactGroup } from './utils';
import { KimMessageArtifact } from '../../../../../../../../../../backend/src/matter/subset/thread/kim-message-artifact.entity';
import { Icon } from '@/new/components/icon';

function GridSkeleton() {
  return (
    <div className="grid grid-cols-3 gap-4">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex flex-col">
          <div className="aspect-[4/3] animate-pulse rounded-xl bg-gray-100" />
          <div className="mt-3 h-4 w-2/3 animate-pulse rounded bg-gray-100" />
          <div className="mt-1.5 h-3 w-1/2 animate-pulse rounded bg-gray-50" />
        </div>
      ))}
    </div>
  );
}

function EmptyState({ message }: { message: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-10 text-gray-500">
      <Icon className="lucide--folder-closed size-3.5" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

export function GroupedArtifactGrid({
  groups,
  isLoading,
  emptyMessage,
  onTogglePublished,
  onDownload,
  onShowVersions,
  togglingKey,
}: {
  groups: ArtifactGroup[];
  isLoading: boolean;
  emptyMessage: string;
  onTogglePublished: (params: { artifactId: string; versionNumber: number }) => void;
  onDownload: (artifactId: string, versionNumber: number) => void;
  onShowVersions: (group: ArtifactGroup) => void;
  togglingKey: string | null;
}) {
  if (isLoading) return <GridSkeleton />;
  if (!groups.length) return <EmptyState message={emptyMessage} />;

  return (
    <div className="grid grid-cols-3 gap-4">
      {groups.map((group) => (
        <ArtifactCard
          key={group.latest.id}
          artifact={group.latest}
          versions={group.versions}
          onTogglePublished={onTogglePublished}
          onDownload={onDownload}
          onShowVersions={onShowVersions}
          togglingKey={togglingKey}
        />
      ))}
    </div>
  );
}

export function FlatArtifactGrid({
  artifacts,
  isLoading,
  emptyMessage,
  onTogglePublished,
  onDownload,
  togglingKey,
}: {
  artifacts?: KimMessageArtifact[];
  isLoading: boolean;
  emptyMessage: string;
  onTogglePublished: (params: { artifactId: string; versionNumber: number }) => void;
  onDownload: (artifactId: string, versionNumber: number) => void;
  togglingKey: string | null;
}) {
  if (isLoading) return <GridSkeleton />;
  if (!artifacts?.length) return <EmptyState message={emptyMessage} />;

  return (
    <div className="grid grid-cols-3 gap-4">
      {artifacts.map((artifact) => (
        <ArtifactCard
          key={`${artifact.id}-${artifact.versionNumber}`}
          artifact={artifact}
          onTogglePublished={onTogglePublished}
          onDownload={onDownload}
          togglingKey={togglingKey}
        />
      ))}
    </div>
  );
}
